import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";

function WelcomeMessageSuccessModal(props) {
  return (
    <BasicModal
      popupOpen={props?.createPublishUnPublishSuccessMsg !== ""}
      logo={"/Images/approve-qc.png"}
      bodyMessage={<p className="mt-2">{props?.createPublishUnPublishSuccessMsg}</p>}
      footer={
        {
          secondaryButton: {
            buttonName: "OK",
            action: props?.onOk,
            buttonPrimaryCustomCss: 'cancel-btn_new'
          }
        }
      }
    />
  );
}

export default WelcomeMessageSuccessModal;
